<template>
  <v-app>
    <!-- global loading screen  -->
    <v-overlay z-index="9999" v-if="globalLoading" style="background-color: #a7a7a72e;">
      <span class="font-weight-black black--text mr-2">cargando</span>
      <v-progress-circular
      :size="15"
        indeterminate
        color="primary darken-2"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="showWarningModal" max-width="400">
      <v-card>
        <v-card-title class="headline">Sesión inactiva</v-card-title>
        <v-card-text>
          Tu sesión se cerrará en {{ countdown }} segundos por inactividad.
          <br />
          ¿Deseas continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="stayLoggedIn">Seguir activo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- global loading screen  -->
    <!-- <v-app-bar app v-if="flagLoggedIn" elevation="0"> -->
    <AppBar v-if="flagLoggedIn" />
    <!-- </v-app-bar> -->
    <div class="mt-6"></div>
    <!-- Sizes your content based upon application components -->
    <v-main class="mt-12">
      <!-- Provides the application the proper gutter -->
      <router-view></router-view>
    </v-main>

    <!-- <v-footer app> -->
    <!-- -->
    <!-- </v-footer> -->
  </v-app>
</template>

<script>
import AppBar from './AppBar.vue';
//import { mapState } from 'vuex';
export default {
  name: 'App',
  components: {
    AppBar,
  },
  data: () => ({
    flag_inactivo: null,
    showWarningModal: false,
    countdown: 20,
    countdownTimer: null,
    warningTime: 20 * 1000, // 20 segundos
  }),
   methods: {
    startWarningCountdown() {
      if (this.countdownTimer) return; // evita múltiples timers
      this.showWarningModal = true;
      this.countdown = this.warningTime / 1000;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        console.log('countdown: ', this.countdown);
        if (this.countdown <= 0) {
          this.cancelCountdown();
          this.logout();
        }
      }, 1000);
    },
    cancelCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = this.warningTime / 1000;
      this.showWarningModal = false;
    },
    stayLoggedIn() {
      this.cancelCountdown();
      // Simular actividad del usuario para reiniciar el timer de idle-vue
      document.dispatchEvent(new Event('mousemove'));
    },
    async logout() {
      //this.cancelCountdown();
      console.log('Sesión cerrada por inactividad');
      // Aquí llamas tu método de logout real
      this.showWarningModal = false,
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
  // Hooks de idle-vue
  onIdle() {
    console.log('Usuario inactivo...');
    if (this.currentUser != null) {
      this.startWarningCountdown();  
    }
    
  },
  async onActive() {
    console.log('Usuario activo nuevamente');
    if (this.currentUser == null) {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }

    this.cancelCountdown();
  },
  computed: {
    currentUser() {
      if (this.$store.state.auth.payload.usuario) {
        return this.$store.state.auth.payload.usuario;
      } else {
        return null;
      }
    },
    // prettier-ignore
    // bottonMargin(){
    //   let aliveSnackbars = this.snackbars.filter((s) => s.show);
    //   return aliveSnackbars.length;
    // },
    //...mapState(['snackbars']
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    flagLoggedIn() {
      return this.$store.state.auth.accessToken ? true : false;
    },
  },
};
</script>
<style>
table > tbody > tr > td {
  font-size: 11px !important;
}
.v-alert {
  position: fixed;
  left: 50%;
  bottom: 50px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
/* prettier-ignore */
.v-overlay__scrim{
  display: none!important;
}
</style>
